import {
  StyledStack,
  StyledSection,
  StyledHeadline,
  SingleBenefitWrapper,
  StyledBenefitHeadline,
  StyledBenefitsWrapper,
  StyledBenefitDescription,
  StyledWhyList,
  StyledIconWrapper,
  StyledIcon,
  StyledIconBackground,
} from './styles';
import { WhyRFData } from './WhyRF.data';

export const WhyRF = ({ ...props }) => {
  const why = WhyRFData();

  return (
    <StyledSection width="normal">
      <StyledStack {...props}>
        <StyledHeadline
          display={{ xs: 'none', md: 'block' }}
          variant="display_md"
          paragraph>
          Why Rumble Fish?
        </StyledHeadline>
        <StyledHeadline
          display={{ xs: 'block', md: 'none' }}
          variant="display_md"
          paragraph>
          Why Rumble Fish?
        </StyledHeadline>

        <StyledBenefitsWrapper>
          {why.map((el, index) => {
            return (
              <SingleBenefitWrapper key={index}>
                <StyledIconWrapper>
                  <StyledIconBackground>
                    <StyledIcon src={el.icon} alt={el.title} />
                  </StyledIconBackground>
                </StyledIconWrapper>
                <StyledBenefitHeadline variant="strong_500">
                  {el.title}
                </StyledBenefitHeadline>
                <StyledBenefitDescription variant="regular_400">
                  {el.description}
                </StyledBenefitDescription>

                {el?.list && (
                  <StyledWhyList>
                    {el.list.map((item, idx) => (
                      <li key={idx}>
                        <b>{item.title}:</b> {item.description}
                      </li>
                    ))}
                  </StyledWhyList>
                )}
              </SingleBenefitWrapper>
            );
          })}
        </StyledBenefitsWrapper>
      </StyledStack>
    </StyledSection>
  );
};
